import { services } from '@/mocks/team';

export default function ServiceModules() {
  return (
    <section className="bg-foreground-950 text-foreground-50 py-20 md:py-28">
      <div className="wrap">
        <div className="mx-auto max-w-[1280px]">
          <div data-reveal-stagger className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-10 items-end">
            <div className="lg:col-span-7">
              <p className="font-label text-[12px] md:text-[13px] tracking-[0.2em] text-foreground-300">OUR SERVICES</p>
              <h2 className="mt-5 font-display font-normal text-[clamp(2rem,3.4vw,3rem)] leading-[1.1] tracking-[-0.015em]">
                Three practices, one way of working.
              </h2>
            </div>
            <p className="lg:col-span-5 text-[16px] leading-[1.6] text-foreground-300 max-w-md">
              Each area stands on its own, and each connects to the others — because hiring, advice and culture rarely sit apart.
            </p>
          </div>

          <div data-reveal-stagger className="mt-12 md:mt-16 grid grid-cols-1 lg:grid-cols-3 gap-5">
            {services.map((s) => (
              <article
                key={s.number}
                id={s.title.toLowerCase().replace(/[^a-z]+/g, '-')}
                className="group flex flex-col border border-foreground-50/15 bg-foreground-50/[0.03] transition-colors duration-300 ease-ui hover:border-foreground-50/35"
              >
                <div className="w-full h-[220px] md:h-[260px] overflow-hidden bg-foreground-900">
                  <img src={s.image} alt={`${s.title} at Morrow People`} title={`${s.title} — HR & talent advisory`} className="w-full h-full object-cover object-top media-zoom" />
                </div>
                <div className="flex flex-col flex-1 p-6 md:p-8">
                  <div className="flex items-center justify-between gap-4 pb-5 border-b border-foreground-50/15 font-label text-[13px] tracking-[0.12em]">
                    <span className="text-foreground-200 uppercase">{s.title}</span>
                    <span className="text-accent-400">{s.number}</span>
                  </div>
                  <h3 className="mt-7 font-display font-normal text-[26px] md:text-[28px] leading-[1.15]">{s.headline}</h3>
                  <p className="mt-4 text-[15px] leading-[1.65] text-foreground-300 flex-1">{s.body}</p>
                  <ul className="mt-8 border-t border-foreground-50/15">
                    {s.points.map((p) => (
                      <li key={p} className="flex items-center gap-3 py-3 border-b border-foreground-50/15 text-[14px] text-foreground-100">
                        <span className="w-1.5 h-1.5 bg-accent-500 shrink-0"></span>
                        {p}
                      </li>
                    ))}
                  </ul>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}